module.exports = __webpack_public_path__ + "img/info-risk-widget.a7041810.png";